import Image from '@base/Image';
import useWindowSize from '@hooks/useWindowSize';
import { StaticInfoImageWrapper, Heading, ImageWrapper, HR } from './styles';

const StaticInfoImage = ({ cmsData }) => {
  const { isMobile } = useWindowSize();
  if (!cmsData) return null;
  const { selectionPage: { heading, image } = {} } = cmsData;

  return (
    <StaticInfoImageWrapper>
      {isMobile && <Heading>{heading}</Heading>}
      <ImageWrapper>
        <Image src={image} alt="offline-centre" layout="fill" />
      </ImageWrapper>
      {isMobile && <HR />}
    </StaticInfoImageWrapper>
  );
};

export default StaticInfoImage;
